import { combineReducers  } from 'redux';

// Front
import Layout from './layout/reducer';

import User from './auth/user/reducer';

const rootReducer = combineReducers({
    Layout,
    User
});

export default rootReducer;